export const LANGUAGES = [
    { label: "English", code: "en", img: "../../images/flags/england.png", lbl:"Eng"},
    { label: "Italiano", code: "it", img: "../../images/flags/italy.png", lbl:"Ita"},
  ];

export const ROLE_ADMIN = '[ROLE_ADMIN]'
export const ROLE_USER = '[ROLE_USER]'
export const OPENES_URL_PREPROD = 'https://preprod.openes.io/portal/esg/planet/climate-change/5nbDN9jhUpNAldBMY6wl'
export const OPENES_URL = 'https://openes.io/portal/esg/planet/climate-change/5nbDN9jhUpNAldBMY6wl'
